import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BackButton } from '../BackButton';
import { ReturnsButton } from './ReturnsButton';
import { getOrderWithMultiPayload } from './utils';

const mapStateToProps = (state) => ({
  state,
  multiOrders: state.multiOrders,
  page: state.page,
});

export const Component = ({
  s,
  sButton,
  displayReturnSubmitErrorMsg,
  returnSubmitErrorMsg,
  lang,
  loading,
  userPrefIsSaving,
  isDisabledStep3,
  incompleteUserPrefSignUp,
  giftOrder,
  hasBlindItems,
  toStep2,
  returnItems,
  confirmOrder,
  state,
  multiOrders,
  page,
}) => {
  const termsButtonContainerClass = `${s.terms_button_container} terms-button-container`;
  const disabledButtonErrorClass = `${s.disabled_button_error}`;
  const buttonContainerClass = `${s.button_container}`;
  const termsButtonTextClass = `${s.terms_button_text} terms_button_text`;

  return (
    <div className={termsButtonContainerClass}>
      {displayReturnSubmitErrorMsg && (
        <p
          role="alert"
          className={disabledButtonErrorClass}
          dangerouslySetInnerHTML={{ __html: returnSubmitErrorMsg }}
        />
      )}
      <div className={buttonContainerClass}>
        <ReturnsButton
          tier="primary"
          onClick={() => {
            const payload = getOrderWithMultiPayload({
              page,
              state,
              returnItems,
              confirmOrder,
              multiOrders,
            });
            console.log(payload);
          }}
          text={lang['returns.step_3.confirm_button_text']}
          loading={loading || userPrefIsSaving}
          big
          disabled={isDisabledStep3 || loading || userPrefIsSaving || incompleteUserPrefSignUp}
          s={sButton}
        />
        {!loading && !userPrefIsSaving && (
          // (adapted from Angular)
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a onClick={toStep2} href="#">
            <span style={{ pointerEvents: 'none' }}>
              <BackButton visible />
            </span>
          </a>
        )}
      </div>
      <span
        role="heading"
        aria-level="5"
        className={termsButtonTextClass}
        dangerouslySetInnerHTML={{ __html: lang['returns.step_3.refund_disclaimer'] }}
      />
      {giftOrder && lang['returns.step_3.refund_disclaimer_gift'] && (
        <span
          className={termsButtonTextClass}
          dangerouslySetInnerHTML={{ __html: lang['returns.step_3.refund_disclaimer_gift'] }}
          role="heading"
          aria-level="5"
        />
      )}
      {hasBlindItems && (
        <span
          role="heading"
          aria-level="5"
          className={termsButtonTextClass}
          dangerouslySetInnerHTML={{ __html: lang['returns.step_3.blind_item_disclaimer'] }}
        />
      )}
    </div>
  );
};

export const OrderSubmitButtons = connect(mapStateToProps)(Component);

Component.propTypes = {
  s: PropTypes.object.isRequired,
  sButton: PropTypes.object.isRequired,
  displayReturnSubmitErrorMsg: PropTypes.bool,
  loading: PropTypes.bool,
  userPrefIsSaving: PropTypes.bool,
  isDisabledStep3: PropTypes.bool,
  incompleteUserPrefSignUp: PropTypes.bool,
  giftOrder: PropTypes.bool,
  hasBlindItems: PropTypes.bool,
  toStep2: PropTypes.func.isRequired,
  returnItems: PropTypes.array.isRequired,
  confirmOrder: PropTypes.object.isRequired,
  returnSubmitErrorMsg: PropTypes.string,
  lang: PropTypes.object.isRequired,
  state: PropTypes.object,
  multiOrders: PropTypes.any,
  page: PropTypes.any,
};

Component.defaultProps = {
  displayReturnSubmitErrorMsg: false,
  returnSubmitErrorMsg: '',
  loading: false,
  userPrefIsSaving: false,
  isDisabledStep3: false,
  incompleteUserPrefSignUp: false,
  giftOrder: false,
  hasBlindItems: false,
  state: {},
  multiOrders: null,
  page: null,
};
